import type { PdfComponent } from '../../../TermsAndConditionsRender/components/typed';

export const SECTION11: PdfComponent = {
  type: 'section',
  id: 's1s11',
  title: '11. Survival of Terms',
  content: [
    {
      type: 'altText',
      id: 's1s11bullets',
      content: [
        'The provisions of this Schedule shall survive the termination or expiry of this Agreement.',
      ],
      boldFirst: false,
    },
  ],
};
